import * as Constants from "../../../constants/urls";
import axios from "axios";

export const GET = (token) => {
    return new Promise((resolve, reject) => {
        // Make your API call here
        // Example:
        const url = Constants.apiUrl + `/api/rfm/setting/get`;

        fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export function UPDATE(formdata, cookies) {

    const url = Constants.apiUrl + `/api/rfm/setting/update`;
    axios.post(url, formdata, {
        headers: {
            'Authorization': 'Bearer ' + cookies,
        }
    }).then((response) => {

    }).catch((error) => {

    });
}
